/**
 * NO03 - Fakturakopi API Calls
 */

import axios, { AxiosRequestConfig } from 'axios';
import { NO03SearchParams } from '../models/NO03';
import FirmNavnId from '../models/FirmNavnId';
import Utils from './Utils';
import CSharpUtils from './CSharpUtils';

const timeout = 30000;

/**
 * Search for invoice summary
 * GET /api/v2/invoices/summary
 * Backend expects: CompanyId, CustomerNumber, FromDate, ToDate, InvoiceNumber, OrderNumber, Amount
 */
export const searchInvoices = (searchParams: NO03SearchParams) => {
  // Map frontend params to backend contract
  const backendParams: any = {
    CompanyId: searchParams.companyId,
    Page: searchParams.page ?? 0,
    PageSize: searchParams.pageSize ?? 100,
  };

  // Add optional filters
  if (searchParams.customerNumber !== undefined && searchParams.customerNumber !== null) {
    backendParams.CustomerNumber = searchParams.customerNumber;
  }
  if (searchParams.fromDate) {
    backendParams.FromDate = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    backendParams.ToDate = searchParams.toDate;
  }
  if (searchParams.invoiceNumber) {
    backendParams.InvoiceNumber = searchParams.invoiceNumber;
  }
  if (searchParams.orderNumber) {
    backendParams.OrderNumber = searchParams.orderNumber;
  }
  if (searchParams.amount !== undefined && searchParams.amount !== null) {
    backendParams.Amount = searchParams.amount;
  }

  const config: AxiosRequestConfig = {
    method: 'get',
    baseURL: `${Utils.URL_ADDRESS}${Utils.DOTNET_DEV_SERVICE}/invoices/summary`,
    timeout,
    headers: {
      'content-type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('token'),
    },
    params: backendParams,
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
  };
  return axios.request(config);
};

/**
 * Get invoice PDF
 * GET /api/invoices/pdf
 */
export const getInvoicePDF = (fakturanr: string) => {
  const config: AxiosRequestConfig = {
    method: 'get',
    baseURL: `${Utils.URL_ADDRESS}${Utils.DOTNET_DEV_SERVICE}/invoices/pdf`,
    timeout,
    headers: {
      'content-type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('token'),
    },
    params: { fakturanr },
    responseType: 'blob', // Important for PDF download
    responseEncoding: 'binary',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
  };
  return axios.request(config);
};

/**
 * Get firma list for the logged-in user
 */
export const getFirmaList = () => {
  const config: AxiosRequestConfig = {
    method: 'get',
      baseURL: `${Utils.URL_ADDRESS}${Utils.DOTNET_DEV_SERVICE}/admin/getalladminFirmfromdb`,
    timeout,
    headers: {
      'content-type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('token'),
    },
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
  };
  return axios.request(config);
};

/**
 * Export invoices to Excel
 */
export const exportInvoicesToExcel = (searchParams: NO03SearchParams) => {
  // Map frontend params to backend contract (same as search)
  const backendParams: any = {
    CompanyId: searchParams.companyId,
    Page: searchParams.page ?? 0,
    PageSize: searchParams.pageSize ?? 100,
  };

  if (searchParams.customerNumber !== undefined && searchParams.customerNumber !== null) {
    backendParams.CustomerNumber = searchParams.customerNumber;
  }
  if (searchParams.fromDate) {
    backendParams.FromDate = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    backendParams.ToDate = searchParams.toDate;
  }
  if (searchParams.invoiceNumber) {
    backendParams.InvoiceNumber = searchParams.invoiceNumber;
  }
  if (searchParams.orderNumber) {
    backendParams.OrderNumber = searchParams.orderNumber;
  }
  if (searchParams.amount !== undefined && searchParams.amount !== null) {
    backendParams.Amount = searchParams.amount;
  }

  const config: AxiosRequestConfig = {
    method: 'get',
    baseURL: `${Utils.URL_ADDRESS}${Utils.DOTNET_DEV_SERVICE}/api/v2/invoices/export`,
    timeout,
    headers: {
      'content-type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('token'),
    },
    params: backendParams,
    responseType: 'blob',
    responseEncoding: 'binary',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
  };
  return axios.request(config);
};
